(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ship-product"] && !Shopify.designMode) return;
  try {
    (function () {
    var postcodeIndex = null;
    var postcodeLoader = null;
    var postcodeKeys = null;

    function getRoot() {
      var root = "/";
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        root = window.Shopify.routes.root;
      }
      if (root.charAt(root.length - 1) !== "/") root += "/";
      return root;
    }

    function buildUrl(path) {
      return getRoot() + path;
    }

    function requestJson(url, options) {
      return fetch(url, options).then(function (response) {
        if (!response.ok) throw new Error("Request failed");
        return response.json();
      });
    }

    function getPostcodeData() {
      if (Array.isArray(window.AU_POSTCODES)) return window.AU_POSTCODES;
      if (Array.isArray(window.australianPostcodes)) return window.australianPostcodes;
      return null;
    }

    function loadPostcodes() {
      if (getPostcodeData()) return Promise.resolve();
      if (postcodeLoader) return postcodeLoader;
      var scriptUrl = "";
      var scriptHost = document.querySelector("[data-postcode-script]");
      if (scriptHost && scriptHost.dataset.postcodeScript) {
        scriptUrl = scriptHost.dataset.postcodeScript;
      } else {
        scriptUrl = buildUrl("assets/c-australian-postcodes.min.js");
      }
      postcodeLoader = new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[data-au-postcodes="true"]');
        if (existing && existing.dataset.loaded === "true") {
          resolve();
          return;
        }
        var script = document.createElement("script");
        script.async = true;
        script.src = scriptUrl;
        script.dataset.auPostcodes = "true";
        script.onload = function () {
          script.dataset.loaded = "true";
          resolve();
        };
        script.onerror = function () {
          postcodeLoader = null;
          reject(new Error("Postcode load failed"));
        };
        document.head.appendChild(script);
      });
      return postcodeLoader;
    }

    function buildIndex() {
      if (postcodeIndex) return postcodeIndex;
      var data = getPostcodeData();
      if (!data) return null;
      var index = {};
      for (var i = 0; i < data.length; i++) {
        var entry = data[i] || {};
        var key = entry.postcode != null ? String(entry.postcode) : "";
        if (!key) continue;
        if (!index[key]) index[key] = [];
        index[key].push(entry);
      }
      postcodeIndex = index;
      return postcodeIndex;
    }

    function getPostcodeKeys() {
      if (postcodeKeys) return postcodeKeys;
      var index = buildIndex();
      if (!index) return null;
      postcodeKeys = Object.keys(index);
      postcodeKeys.sort();
      return postcodeKeys;
    }

    function normalizePostcode(value) {
      var digits = String(value || "").replace(/\D/g, "");
      if (!digits) return "";
      var num = parseInt(digits, 10);
      if (isNaN(num)) return "";
      return String(num);
    }

    function dedupeEntries(entries) {
      var map = {};
      var result = [];
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i] || {};
        var locality = String(entry.locality || "").trim();
        var state = String(entry.state || "").trim();
        var key = locality + "|" + state;
        if (!locality || map[key]) continue;
        map[key] = true;
        result.push({ locality: locality, state: state, postcode: entry.postcode });
      }
      result.sort(function (a, b) {
        var locA = a.locality.toLowerCase();
        var locB = b.locality.toLowerCase();
        if (locA < locB) return -1;
        if (locA > locB) return 1;
        var stA = a.state.toLowerCase();
        var stB = b.state.toLowerCase();
        if (stA < stB) return -1;
        if (stA > stB) return 1;
        return 0;
      });
      return result;
    }

    function wait(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function setHint(hintEl, message, isError) {
      if (!hintEl) return;
      hintEl.textContent = message || "";
      if (isError) {
        hintEl.classList.add("is-error");
      } else {
        hintEl.classList.remove("is-error");
      }
    }

    function setLoading(button, isLoading, label) {
      if (!button) return;
      if (isLoading) {
        button.disabled = true;
        button.setAttribute("aria-busy", "true");
        if (!button.dataset.originalText) {
          button.dataset.originalText = button.textContent;
        }
        button.textContent = label || button.textContent;
      } else {
        button.disabled = false;
        button.removeAttribute("aria-busy");
        if (button.dataset.originalText) {
          button.textContent = button.dataset.originalText;
          delete button.dataset.originalText;
        }
      }
    }

    function renderRates(resultsEl, rates, emptyMessage, shippingLabel, currencySymbol) {
      if (!resultsEl) return;
      resultsEl.innerHTML = "";
      if (!rates || !rates.length) {
        resultsEl.innerHTML = '<p class="shipping-empty">' + (emptyMessage || "") + "</p>";
        return;
      }
      for (var i = 0; i < rates.length; i++) {
        var rate = rates[i] || {};
        var row = document.createElement("div");
        row.className = "shipping-option";

        var name = document.createElement("span");
        name.textContent = rate.name || shippingLabel || "";

        var price = document.createElement("span");
        var rawPrice = rate.price != null ? String(rate.price) : "";
        price.textContent = rawPrice ? (currencySymbol || "") + rawPrice : "";

        row.appendChild(name);
        row.appendChild(price);
        resultsEl.appendChild(row);
      }
    }

    function getVariantId(widget) {
      var value = "";
      var form = widget ? widget.closest("form") : null;
      var input = form ? form.querySelector('input[name="id"]') : null;
      if (!input) {
        input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      }
      if (input && input.value) value = input.value;
      if (!value && widget) value = widget.dataset.variantId || "";
      return String(value || "").trim();
    }

    function getQuantity(widget) {
      var value = 1;
      var form = widget ? widget.closest("form") : null;
      var input = form ? form.querySelector('input[name="quantity"]') : null;
      if (!input) {
        input = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      }
      if (input && input.value) {
        var parsed = parseInt(input.value, 10);
        if (!isNaN(parsed) && parsed > 0) value = parsed;
      }
      return value;
    }

    function getCart() {
      return requestJson(buildUrl("cart.js"), { credentials: "same-origin" });
    }

    function clearCart() {
      return requestJson(buildUrl("cart/clear.js"), { method: "POST", credentials: "same-origin" });
    }

    function addItems(items) {
      return requestJson(buildUrl("cart/add.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ items: items })
      });
    }

    function updateCart(payload) {
      return requestJson(buildUrl("cart/update.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "same-origin",
        body: JSON.stringify(payload)
      });
    }

    function addItemsInBatches(items) {
      var batchSize = 20;
      var chain = Promise.resolve();
      for (var i = 0; i < items.length; i += batchSize) {
        (function (batch) {
          chain = chain.then(function () {
            return addItems(batch);
          });
        })(items.slice(i, i + batchSize));
      }
      return chain;
    }

    function snapshotCart(cart) {
      var items = [];
      if (cart && Array.isArray(cart.items)) {
        for (var i = 0; i < cart.items.length; i++) {
          var item = cart.items[i] || {};
          var variantId = item.variant_id || item.id;
          if (!variantId) continue;
          var entry = { id: variantId, quantity: item.quantity || 1 };
          if (item.properties && typeof item.properties === "object") {
            var keys = Object.keys(item.properties);
            if (keys.length) entry.properties = item.properties;
          }
          var planId = item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.id;
          if (planId) entry.selling_plan = planId;
          items.push(entry);
        }
      }
      var discountCodes = [];
      if (cart && Array.isArray(cart.discount_codes)) {
        for (var j = 0; j < cart.discount_codes.length; j++) {
          var code = cart.discount_codes[j] && cart.discount_codes[j].code;
          if (code) discountCodes.push(code);
        }
      }
      return {
        items: items,
        note: cart ? cart.note : null,
        attributes: cart ? cart.attributes : null,
        discountCodes: discountCodes
      };
    }

    function restoreCart(snapshot) {
      if (!snapshot) return Promise.resolve();
      return clearCart()
        .then(function () {
          if (snapshot.items.length) return addItemsInBatches(snapshot.items);
          return null;
        })
        .then(function () {
          var payload = {};
          if (snapshot.note !== null && snapshot.note !== undefined) payload.note = snapshot.note;
          if (snapshot.attributes && Object.keys(snapshot.attributes).length) payload.attributes = snapshot.attributes;
          if (snapshot.discountCodes && snapshot.discountCodes.length) payload.discount = snapshot.discountCodes.join(",");
          if (Object.keys(payload).length) return updateCart(payload);
          return null;
        });
    }

    function pollShippingRates(url, attempts, delayMs) {
      var count = 0;
      function check() {
        return fetch(url, { credentials: "same-origin" })
          .then(function (response) {
            if (!response.ok) throw new Error("Request failed");
            return response.text();
          })
          .then(function (text) {
            var data = null;
            if (text) {
              try {
                data = JSON.parse(text);
              } catch (e) {
                data = null;
              }
            }
            if (data && data.shipping_rates) return data.shipping_rates;
            count += 1;
            if (count >= attempts) return null;
            return wait(delayMs).then(check);
          });
      }
      return check();
    }

    function prepareShippingRates(address) {
      var params = new URLSearchParams();
      if (address.zip) params.set("shipping_address[zip]", address.zip);
      if (address.country) params.set("shipping_address[country]", address.country);
      if (address.province) params.set("shipping_address[province]", address.province);
      if (address.city) params.set("shipping_address[city]", address.city);
      var query = params.toString();
      var prepareUrl = buildUrl("cart/prepare_shipping_rates.json" + (query ? "?" + query : ""));
      var asyncUrl = buildUrl("cart/async_shipping_rates.json" + (query ? "?" + query : ""));
      return fetch(prepareUrl, { method: "POST", credentials: "same-origin" }).then(function () {
        return pollShippingRates(asyncUrl, 12, 500);
      });
    }

    function initWidget(widget) {
      if (!widget || widget.dataset.shippingCalculatorInit === "true") return;
      widget.dataset.shippingCalculatorInit = "true";
      var busy = false;

      var postcodeInput = widget.querySelector("[data-postcode]");
      var suggestionsEl = widget.querySelector("[data-suggestions]");
      var suburbSelect = widget.querySelector("[data-suburb]");
      var stateInput = widget.querySelector("[data-state]");
      var calcButton = widget.querySelector("[data-calc]");
      var useLocationBtn = widget.querySelector("[data-use-location]");
      var clearButton = widget.querySelector("[data-clear]");
      var floatingLabel = widget.querySelector("[data-floating-label]");
      var hintEl = widget.querySelector("[data-hint]");
      var resultsEl = widget.querySelector("[data-results]");
      var texts = {
        postcodeUnavailable: "Postcode data unavailable.",
        postcodeNotFound: "We could not find that postcode.",
        selectSuburbPlaceholder: "Select suburb",
        checkingRates: "Checking shipping rates...",
        checkingButton: "Checking...",
        invalidPostcode: "Enter a valid postcode.",
        selectSuburb: "Select a suburb.",
        stateRequired: "Select a suburb to set the state.",
        noRates: "No shipping rates available.",
        ratesError: "We could not load shipping rates. Please try again.",
        shippingLabel: "Shipping",
        loadingPostcodes: "Loading postcode data...",
        restoreError: "We could not restore your cart. Please refresh the page.",
        locating: "Locating...",
        locationNotSupported: "Location is not supported on this device.",
        locationPermissionDenied: "Location permission was denied.",
        locationUnavailable: "We could not access your location.",
        locationTimeout: "Location request timed out. Please try again.",
        locationFailed: "We could not use your location. Please try again.",
        locationNoPostcode: "We could not find a postcode for your location."
      };
      var country = widget.dataset.country || "Australia";
      var currencySymbol = widget.dataset.currencySymbol || "$";
      var autoCheckOnSelect = widget.dataset.autoCheckOnSelect === "true";
      var suggestionQuery = "";
      var keepSuggestionsOpen = false;

      function clearSuburbs(message) {
        if (!suburbSelect) return;
        suburbSelect.innerHTML = "";
        var option = document.createElement("option");
        option.value = "";
        option.textContent = message || texts.selectSuburbPlaceholder || "";
        suburbSelect.appendChild(option);
        suburbSelect.disabled = true;
      }

      function setState(value) {
        if (stateInput) stateInput.value = value || "";
      }

      function updateInputUI() {
        if (!postcodeInput) return;
        var hasValue = String(postcodeInput.value || "").trim().length > 0;
        if (floatingLabel) {
          floatingLabel.classList.toggle("is-floating", hasValue);
        }
        if (clearButton) clearButton.hidden = !hasValue;
      }

      function clearInput() {
        if (!postcodeInput) return;
        postcodeInput.value = "";
        suggestionQuery = "";
        updateInputUI();
        clearSuggestions();
        clearSuburbs(texts.selectSuburbPlaceholder);
        setState("");
        setHint(hintEl, "", false);
        if (resultsEl) resultsEl.innerHTML = "";
      }

      function getSuggestionsList() {
        if (!suggestionsEl) return null;
        return suggestionsEl.querySelector(".shipping-calculator__suggestions-list");
      }

      function clearSuggestions() {
        if (!suggestionsEl) return;
        var list = getSuggestionsList();
        if (list) list.innerHTML = "";
        suggestionsEl.hidden = true;
        if (postcodeInput) postcodeInput.setAttribute("aria-expanded", "false");
      }

      function renderSuggestions(entries) {
        if (!suggestionsEl) return;
        if (!entries || !entries.length) {
          clearSuggestions();
          return;
        }
        var list = getSuggestionsList();
        if (!list) return;
        list.innerHTML = "";
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var item = document.createElement("li");
          item.className = "shipping-calculator__suggestion-item" + (i === 0 ? " is-active" : "");

          var option = document.createElement("button");
          option.type = "button";
          option.className = "shipping-calculator__suggestion-button";
          option.setAttribute("role", "option");
          option.dataset.suggestion = "true";
          option.dataset.postcode = entry.postcode;
          option.dataset.locality = entry.locality;
          option.dataset.state = entry.state;
          option.textContent = entry.locality + " " + entry.state + " " + entry.postcode;

          item.appendChild(option);
          list.appendChild(item);
        }
        suggestionsEl.hidden = false;
        if (postcodeInput) postcodeInput.setAttribute("aria-expanded", "true");
      }

      function getSuggestionEntries(query) {
        var rawQuery = String(query || "").trim();
        if (!rawQuery) return [];
        var index = buildIndex();
        var keys = getPostcodeKeys();
        var normalized = normalizePostcode(rawQuery);
        var hasLetters = /[a-z]/i.test(rawQuery);
        var results = [];
        var seen = {};
        if (normalized.length >= 2 && index && keys) {
          for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (key.indexOf(normalized) !== 0) continue;
            var matches = dedupeEntries(index[key] || []);
            for (var j = 0; j < matches.length; j++) {
              var entry = matches[j];
              var entryKey = key + "|" + entry.locality + "|" + entry.state;
              if (seen[entryKey]) continue;
              seen[entryKey] = true;
              results.push({ postcode: key, locality: entry.locality, state: entry.state });
              if (results.length >= 8) return results;
            }
          }
        }
        if (results.length >= 8 || !hasLetters) return results;
        var data = getPostcodeData();
        if (!Array.isArray(data)) return results;
        var term = rawQuery.toLowerCase();
        if (term.length < 2) return results;
        for (var k = 0; k < data.length; k++) {
          var row = data[k] || {};
          var locality = String(row.locality || "").trim();
          var state = String(row.state || "").trim();
          var postcode = row.postcode != null ? String(row.postcode) : "";
          if (!locality || !state || !postcode) continue;
          if (locality.toLowerCase().indexOf(term) !== 0) continue;
          var rowKey = postcode + "|" + locality + "|" + state;
          if (seen[rowKey]) continue;
          seen[rowKey] = true;
          results.push({ postcode: postcode, locality: locality, state: state });
          if (results.length >= 8) break;
        }
        return results;
      }

      function refreshSuggestions() {
        if (!postcodeInput || !suggestionsEl) return;
        var raw = String(postcodeInput.value || "").trim();
        suggestionQuery = raw;
        if (!raw) {
          clearSuggestions();
          return;
        }
        loadPostcodes()
          .then(function () {
            if (suggestionQuery !== raw) return;
            var entries = getSuggestionEntries(raw);
            if (suggestionQuery !== raw) return;
            renderSuggestions(entries);
          })
          .catch(function () {
            clearSuggestions();
          });
      }

      function applySuggestion(entry) {
        if (!entry || !postcodeInput) return;
        postcodeInput.value = entry.postcode;
        clearSuggestions();
        updateInputUI();
        updateSuburbs(entry);
      }

      function setLocationLoading(isLoading) {
        if (!useLocationBtn) return;
        var labelTarget = useLocationBtn.querySelector("span") || useLocationBtn;
        useLocationBtn.disabled = !!isLoading;
        if (isLoading) {
          if (!useLocationBtn.dataset.originalText) {
            useLocationBtn.dataset.originalText = labelTarget.textContent;
          }
          labelTarget.textContent = texts.locating || labelTarget.textContent;
        } else if (useLocationBtn.dataset.originalText) {
          labelTarget.textContent = useLocationBtn.dataset.originalText;
          delete useLocationBtn.dataset.originalText;
        }
      }

      function extractPostcode(data) {
        if (!data || typeof data !== "object") return "";
        var postcode = data.postcode || data.postalCode || data.postalcode;
        if (!postcode && data.address) {
          postcode = data.address.postcode || data.address.postalCode || data.address.postalcode;
        }
        return String(postcode || "").trim();
      }

      function fetchPostcodeForCoords(lat, lon) {
        var url =
          "https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=" +
          encodeURIComponent(lat) +
          "&longitude=" +
          encodeURIComponent(lon) +
          "&localityLanguage=en";
        return requestJson(url).then(function (data) {
          return extractPostcode(data);
        });
      }

      function useLocation() {
        if (!postcodeInput || !useLocationBtn) return;
        if (!navigator.geolocation) {
          setHint(hintEl, texts.locationNotSupported, true);
          return;
        }
        setLocationLoading(true);
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var coords = position && position.coords ? position.coords : null;
            if (!coords) {
              setHint(hintEl, texts.locationFailed, true);
              setLocationLoading(false);
              return;
            }
            fetchPostcodeForCoords(coords.latitude, coords.longitude)
              .then(function (postcode) {
                if (!postcode) {
                  setHint(hintEl, texts.locationNoPostcode, true);
                  return;
                }
                postcodeInput.value = postcode;
                updateInputUI();
                clearSuggestions();
                return updateSuburbs().then(function () {
                  keepSuggestionsOpen = true;
                  refreshSuggestions();
                  setTimeout(function () {
                    keepSuggestionsOpen = false;
                  }, 1000);
                });
              })
              .catch(function () {
                setHint(hintEl, texts.locationFailed, true);
              })
              .finally(function () {
                setLocationLoading(false);
              });
          },
          function (error) {
            var message = texts.locationFailed;
            if (error && error.code === 1) message = texts.locationPermissionDenied;
            if (error && error.code === 2) message = texts.locationUnavailable;
            if (error && error.code === 3) message = texts.locationTimeout;
            setHint(hintEl, message, true);
            setLocationLoading(false);
          },
          { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
        );
      }

      function updateSuburbs(preferredEntry) {
        if (!postcodeInput || !suburbSelect) return Promise.resolve([]);
        var postcode = normalizePostcode(postcodeInput.value);
        if (!postcode) {
          clearSuburbs(texts.selectSuburbPlaceholder);
          setState("");
          setHint(hintEl, "", false);
          return Promise.resolve([]);
        }
        setHint(hintEl, texts.loadingPostcodes, false);
        return loadPostcodes()
          .then(function () {
            var index = buildIndex();
            if (!index) {
              clearSuburbs(texts.selectSuburbPlaceholder);
              setHint(hintEl, texts.postcodeUnavailable, true);
              return [];
            }

            var entries = dedupeEntries(index[postcode] || []);
            if (!entries.length) {
              clearSuburbs(texts.selectSuburbPlaceholder);
              setState("");
              if (postcode.length >= 4) {
                setHint(hintEl, texts.postcodeNotFound, true);
              } else {
                setHint(hintEl, "", false);
              }
              return [];
            }

            suburbSelect.innerHTML = "";
            var placeholder = document.createElement("option");
            placeholder.value = "";
            placeholder.textContent = texts.selectSuburbPlaceholder || "";
            suburbSelect.appendChild(placeholder);

            for (var i = 0; i < entries.length; i++) {
              var entry = entries[i];
              var option = document.createElement("option");
              option.value = entry.locality;
              option.textContent = entry.locality + " (" + entry.state + ")";
              option.dataset.state = entry.state;
              suburbSelect.appendChild(option);
            }

            suburbSelect.disabled = false;
            setHint(hintEl, "", false);

            var selected = null;
            if (preferredEntry && preferredEntry.locality) {
              for (var j = 0; j < entries.length; j++) {
                if (entries[j].locality === preferredEntry.locality && entries[j].state === preferredEntry.state) {
                  selected = entries[j];
                  break;
                }
              }
            }

            var notifyChange = false;
            if (selected) {
              suburbSelect.value = selected.locality;
              setState(selected.state);
              notifyChange = true;
            } else if (entries.length === 1) {
              suburbSelect.value = entries[0].locality;
              setState(entries[0].state);
              notifyChange = true;
            } else {
              setState("");
            }
            if (notifyChange) onSuburbChange();

            return entries;
          })
          .catch(function () {
            clearSuburbs(texts.selectSuburbPlaceholder);
            setState("");
            setHint(hintEl, texts.postcodeUnavailable, true);
            return [];
          });
      }

      function onSuburbChange() {
        if (!suburbSelect) return;
        var selected = suburbSelect.options[suburbSelect.selectedIndex];
        setState(selected ? selected.dataset.state || "" : "");
        if (!autoCheckOnSelect) return;
        var postcode = normalizePostcode(postcodeInput ? postcodeInput.value : "");
        var suburb = String(suburbSelect.value || "").trim();
        var state = String(stateInput ? stateInput.value : "").trim();
        if (postcode && suburb && state) fetchRates();
      }

      function fetchRates() {
        if (!postcodeInput || !suburbSelect) return;
        if (busy) return;
        var postcode = normalizePostcode(postcodeInput.value);
        var suburb = String(suburbSelect.value || "").trim();
        var state = String(stateInput ? stateInput.value : "").trim();

        if (!postcode) {
          setHint(hintEl, texts.invalidPostcode, true);
          return;
        }
        if (!suburb) {
          setHint(hintEl, texts.selectSuburb, true);
          return;
        }
        if (!state) {
          setHint(hintEl, texts.stateRequired, true);
          return;
        }

        busy = true;
        setHint(hintEl, texts.checkingRates, false);
        setLoading(calcButton, true, texts.checkingButton);
        if (resultsEl) resultsEl.innerHTML = "";

        var snapshot = null;
        var address = {
          zip: postcode,
          country: country,
          province: state,
          city: suburb
        };

        getCart()
          .then(function (cart) {
            snapshot = snapshotCart(cart);
            return clearCart();
          })
          .then(function () {
            var variantId = getVariantId(widget);
            var quantity = getQuantity(widget);
            if (!variantId) throw new Error("Variant missing");
            return addItems([{ id: variantId, quantity: quantity }]);
          })
          .then(function () {
            return prepareShippingRates(address);
          })
          .then(function (rates) {
            renderRates(resultsEl, rates || [], texts.noRates, texts.shippingLabel, currencySymbol);
            setHint(hintEl, "", false);
          })
          .catch(function () {
            setHint(hintEl, texts.ratesError, true);
          })
          .then(function () {
            return restoreCart(snapshot);
          })
          .catch(function () {
            setHint(hintEl, texts.restoreError, true);
          })
          .finally(function () {
            busy = false;
            setLoading(calcButton, false, texts.checkingButton);
          });
      }

      if (postcodeInput) {
        postcodeInput.addEventListener("input", function () {
          updateInputUI();
          var digitLength = String(postcodeInput.value || "").replace(/\D/g, "").length;
          refreshSuggestions();
          if (digitLength >= 3) {
            updateSuburbs();
          } else {
            clearSuburbs(texts.selectSuburbPlaceholder);
            setState("");
            setHint(hintEl, "", false);
          }
        });
        postcodeInput.addEventListener("focus", refreshSuggestions);
        postcodeInput.addEventListener("blur", function () {
          updateSuburbs();
          if (keepSuggestionsOpen) return;
          setTimeout(clearSuggestions, 150);
        });
        postcodeInput.addEventListener("keydown", function (event) {
          if (event.key !== "Enter" || !suggestionsEl || suggestionsEl.hidden) return;
          var first = suggestionsEl.querySelector("button[data-suggestion]");
          if (!first) return;
          event.preventDefault();
          applySuggestion({
            postcode: first.dataset.postcode || "",
            locality: first.dataset.locality || "",
            state: first.dataset.state || ""
          });
        });
      }

      if (suburbSelect) suburbSelect.addEventListener("change", onSuburbChange);
      if (calcButton) calcButton.addEventListener("click", fetchRates);
      if (useLocationBtn) useLocationBtn.addEventListener("click", useLocation);
      if (clearButton) clearButton.addEventListener("click", clearInput);
      if (suggestionsEl) {
        suggestionsEl.addEventListener("mousedown", function (event) {
          event.preventDefault();
        });
        suggestionsEl.addEventListener("click", function (event) {
          var target = event.target && event.target.closest ? event.target.closest("button[data-suggestion]") : null;
          if (!target) return;
          applySuggestion({
            postcode: target.dataset.postcode || "",
            locality: target.dataset.locality || "",
            state: target.dataset.state || ""
          });
        });
      }
      document.addEventListener("click", function (event) {
        if (!widget.contains(event.target)) clearSuggestions();
      });

      updateInputUI();
      clearSuburbs(texts.selectSuburbPlaceholder);
    }

    document.addEventListener("DOMContentLoaded", function () {
      var widgets = document.querySelectorAll(".ship-product");
      for (var i = 0; i < widgets.length; i++) {
        initWidget(widgets[i]);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
